import { getChoiceLabels } from "utils/formatChoices";
import styles from "../../../Styles/questionCard.module.css";

export default function QuestionCard({
    index,
    config,
    selectedAnswer,
    onSelect,
}) {
    const labels = getChoiceLabels(config.choiceFormat, config.noOfChoices);

    return (
        <div className={styles.questionCard}>
            <div className={styles.questionRow}>
                <div className={styles.questionNumber}>Q{index + 1}.</div>

                <div className={styles.optionsContainer}>
                    {config.questionType === "SCQ" &&
                        labels.map((label) => (
                            <label
                                key={label}
                                className={`${styles.optionBox} ${selectedAnswer === label ? styles.selected : ""
                                    }`}
                            >
                                <input
                                    type="radio"
                                    name={`q-${index}`}
                                    checked={selectedAnswer === label}
                                    onChange={() => onSelect(index, label)}
                                />
                                <span>{label}</span>
                            </label>
                        ))}

                    {config.questionType === "Numerical" && (
                        <input
                            className={styles.numericalInput}
                            type="number"
                            placeholder="Enter answer"
                            value={selectedAnswer || ""}
                            onChange={(e) => onSelect(index, e.target.value)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}